import _ from 'lodash'

const rosterUtil = {
    updateDisplayEmployee: (employees, branches, departments) => {
        let empList = []

        if (!_.isEmpty(branches)) {
            empList = _.filter(employees, function(o) {
                return _.includes(branches, o.EmployeeBranch)
            })

            if (!_.isEmpty(departments)) {
                empList = _.filter(empList, function(o) {
                    return _.includes(
                        departments,
                        o.EmployeeDepartment
                    )
                })
            }
            return empList
        }

        if (!_.isEmpty(departments)) {
            empList = _.filter(employees, function(o) {
                return _.includes(departments, o.EmployeeDepartment)
            })

            if (!_.isEmpty(branches)) {
                empList = _.filter(empList, function(o) {
                    return _.includes(branches, o.EmployeeBranch)
                })
            }

            return empList
        }

        return employees

    },
}

export default rosterUtil
